import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "user";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

export const userGetData = "user/getData/";

export const masterRegion = "Master/Region/list/";
export const masterGajiwebSatker = "Master/GajiWeb/listPegawai/";
export const CoupleList = "Kepegawaian/RiwayatNikah/coupleList/";

export const RiwayatNikahList = "Kepegawaian/RiwayatNikah/list/";
export const RiwayatNikahCreate = "Kepegawaian/RiwayatNikah/create/";
export const RiwayatNikahActive = "Kepegawaian/RiwayatNikah/active/";
export const RiwayatNikahInactive = "Kepegawaian/RiwayatNikah/inactive/";
export const RiwayatNikahDetail = "Kepegawaian/RiwayatNikah/detail/";
export const RiwayatNikahUpdate = "Kepegawaian/RiwayatNikah/update/";
export const RiwayatNikahApprove = "Kepegawaian/RiwayatNikah/approve/";

export const ListStatus = "Kepegawaian/RiwayatNikah/ListStatus/";
export const PendidikanList = "Kepegawaian/RiwayatNikah/pendidikan/";

export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
